import { NavLink, useLocation } from "react-router-dom";
import { House, FileStack, MessageCircleQuestion, SquareChartGantt, Contact, ShoppingCart, User, ListTodo } from "lucide-react";

function Sidebar({ isOpen, setIsOpen }) {
  const location = useLocation();
  const isAccountPage = location.pathname.startsWith('/account');

  const mainMenuItems = [
    { to: "/project", label: "О проекте", icon: House },
    { to: "/capability", label: "Функционал", icon: FileStack },
    { to: "/faq", label: "Вопрос - ответ", icon: MessageCircleQuestion },
    { to: "/contacts", label: "Контакты", icon: Contact }
  ];

  const accountMenuItems = [
    { to: "/account/info", label: "Информация", icon: User },
    { to: "/account/orders", label: "Мои заказы", icon: ListTodo }
  ];

  const menuItems = isAccountPage ? accountMenuItems : mainMenuItems;

  const handleLinkClick = () => {
    // Закрыть меню с небольшой задержкой
    setTimeout(() => setIsOpen(false), 100); // 100ms
  };

  return (
    <aside
      className={`flex w-full flex-col text-[15px] md:sticky md:top-16 md:h-body md:w-[240px] xl:w-[260px] max-md:fixed max-md:inset-0 max-md:z-40 max-md:bg-background/80 max-md:pt-16
        ${
          isOpen ? "bg-gray-100" : "max-md:backdrop-blur-md max-md:hidden"
        }`}
    >
      <div className="sticky top-16 flex flex-col gap-8 pb-10 pt-4 max-md:px-4 md:pr-3 md:pt-10">
        {/* Menu Items */}
        <div className="flex-1 overflow-y-auto">
          {menuItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={handleLinkClick} // Используем обработчик
              className={({ isActive }) =>
                `flex items-center gap-2 rounded-md px-4 py-2 transition-colors duration-100 [&_svg]:size-4 ${
                  isActive
                    ? "bg-gray-200 text-gray-700 font-medium"
                    : "text-gray-500 hover:bg-gray-50 hover:text-gray-600"
                } text-sm`
              }
            >
              <span className="w-4 h-4">{item.icon && <item.icon />}</span>
              {item.label}
            </NavLink>
          ))}
        </div>
      </div>
    </aside>
  );
}

export default Sidebar;
